import { CommentItem } from '@/components/domains/comment/CommentItem';
import { Comment } from '@/types/comment';
import * as React from 'react';
import { useEffect } from 'react';
import { useSession } from 'next-auth/react';

export function CommentList({
  comments,
  onDelete,
}: {
  comments: Comment[];
  onDelete?: (commentId: string) => Promise<void>;
}) {
  const ref = React.useRef<HTMLDivElement>(null);
  const { data } = useSession();

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = ref.current.scrollHeight;
    }
  });

  return (
    <div className="flex flex-grow basis-0 flex-col overflow-y-auto p-2" ref={ref}>
      <div className="flex flex-grow flex-col justify-end gap-2">
        {comments.map((c) => (
          <CommentItem
            position={data?.user?.id == c.user.id ? 'right' : 'left'}
            comment={c}
            key={c.id}
            onDelete={onDelete}
          />
        ))}
      </div>
    </div>
  );
}
